/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

export enum BloodProducts {
  WB = 'Whole Blood',

  PRBC = 'Packed Red Blood Cells',

  FFP = 'FFP - Fresh Frozen Plasma',

  CRYP = 'Cryoprecipitate',

  TCC = 'Thrombin Concentrate',

  RDP = 'RDP - Random Donor Platelets',

  SDP = 'Single Donor Platelets',

  FVIII = 'Factor VIII Concentrates',

  FIX = 'Factor IX Concentrates',

  FB = 'Fresh Blood',

  LBC = 'Leukocyte Reduced Red Blood Cells',

  WRC = 'Washed Red Cells',

  FRC = 'Frozen Red Cells',
}
